import React, { useState, useEffect } from 'react'
import { Modal, Button, Skeleton, message } from 'antd'
import { InventoryLogAPI } from '@getgreenline/inventory'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { InventoryLogsTable } from '../../../../components/InventoryLogs/InventoryLogsTable'
import { parseErrorMsg } from '../../../../utilities/helpers'

interface Props {
  companyId: number
  onHide: () => void
  productName: string
  productId: string
  locationIds: number[]
  startDate: Date
  endDate: Date
}

export const ViewAllLogsModalOCS = React.memo((props: Props) => {
  const { companyId, onHide, productName, productId, locationIds, startDate, endDate } = props

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [logs, setLogs] = useState<IInventoryLog[]>([])

  const loadLogs = async () => {
    setIsLoading(true)

    try {
      const logsPromises = locationIds.map((locationId) => {
        return InventoryLogAPI.getInventoryLogs(companyId, {
          locationId: locationId,
          productIds: [productId],
          startDate: startDate,
          endDate: endDate,
        })
      })
      const logsFromLocations = await Promise.all(logsPromises)
      const flatLogs = logsFromLocations
        .filter((logsFromLocation) => logsFromLocation.data.length > 0)
        .flatMap((next) => next.data)
      setLogs(flatLogs)
    } catch (error) {
      console.error(error)
      message.error(parseErrorMsg(error))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadLogs()
  }, [])

  return (
    <Modal
      title={`${productName}`}
      width={690}
      visible={true}
      footer={[
        <Button key='cancel' onClick={() => onHide()}>
          Cancel
        </Button>,
      ]}
      onCancel={() => onHide()}
    >
      {isLoading ? (
        <Skeleton active />
      ) : (
        <InventoryLogsTable
          companyId={companyId}
          logs={logs}
          onChange={loadLogs}
          isLoading={isLoading}
        />
      )}
    </Modal>
  )
})
